import React from 'react';
import {
  TableContainer, Paper, Box, Typography, Table, TableHead, TableRow, TableCell, TableBody, Tooltip, IconButton
} from '@mui/material';
import ArticleIcon from '@mui/icons-material/Article';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

const stripPreview = (content = '') => {
  try {
    return content.replace(/<[^>]*>/g, '').substring(0, 100) || '';
  } catch (e) {
    return '';
  }
};

export default function AiroNotesManagement({
  blogs, filteredBlogs, blogLoading, blogListError, searchTerm, tab, handleEditBlog, handleDeleteBlog
}) {
  const list = searchTerm ? filteredBlogs : blogs;

  return (
    <TableContainer component={Paper} sx={{ borderRadius: 2, boxShadow: '0 4px 16px rgba(0,0,0,0.1)' }}>
      {blogListError && (
        <Box sx={{ p: 2 }}>
          <Typography variant="body2" color="error">
            {blogListError}
          </Typography>
        </Box>
      )}
      <Table>
        <TableHead>
          <TableRow sx={{ 
            background: 'linear-gradient(135deg, #0D004A 0%, #1a0a6e 100%)',
            '& .MuiTableCell-head': {
              color: 'white',
              fontWeight: 700,
              fontSize: '1rem',
            }
          }}>
            <TableCell sx={{ width: '200px' }}>Title</TableCell>
            <TableCell sx={{ width: '400px', maxWidth: '400px' }}>Content Preview</TableCell>
            <TableCell align="center" sx={{ width: '150px', whiteSpace: 'nowrap' }}>Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {blogLoading && (
            <TableRow>
              <TableCell colSpan={3} align="center" sx={{ py: 8 }}>
                <Typography variant="body2" color="text.secondary">Loading AiroNotes…</Typography>
              </TableCell>
            </TableRow>
          )}
          {!blogLoading && list.map((blog, i) => {
            const originalIndex = blogs.findIndex(b => b === blog);
            const preview = stripPreview(blog.content);
            return (
              <TableRow
                key={blog.id || i}
                sx={{
                  cursor: 'pointer',
                  '&:hover': { backgroundColor: '#f5f5f5' },
                  '&:nth-of-type(even)': { backgroundColor: '#fafafa' },
                  '&:nth-of-type(even):hover': { backgroundColor: '#f0f0f0' },
                }}
              >
                <TableCell sx={{ width: '200px' }}>
                  <Typography variant="body1" sx={{ fontWeight: 600, color: '#0D004A' }}>
                    {blog.title}
                  </Typography>
                </TableCell>
                <TableCell sx={{ width: '400px', maxWidth: '400px' }}>
                  <Typography 
                    variant="body2" 
                    sx={{ 
                      color: '#666', 
                      lineHeight: 1.5,
                      wordWrap: 'break-word',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      display: '-webkit-box',
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: 'vertical',
                    }}
                  >
                    {preview}{preview.length >= 100 ? '...' : ''}
                  </Typography>
                </TableCell>
                <TableCell align="center" sx={{ width: '150px', whiteSpace: 'nowrap' }}>
                  <Tooltip title="Edit">
                    <IconButton size="small" onClick={() => handleEditBlog(originalIndex)} sx={{ color: '#1976d2', p: 0.5 }}>
                      <EditIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Delete">
                    <IconButton size="small" onClick={() => handleDeleteBlog(blog.id)} sx={{ color: '#d32f2f', p: 0.5 }}>
                      <DeleteIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                </TableCell>
              </TableRow>
            );
          })}
          {!blogLoading && list.length === 0 && (
            <TableRow>
              <TableCell colSpan={3} align="center" sx={{ py: 8 }}>
                <ArticleIcon sx={{ fontSize: 64, color: 'text.disabled', mb: 2 }} />
                <Typography variant="h6" sx={{ color: 'text.secondary', mb: 1 }}>
                  {searchTerm ? 'No AiroNotes found' : 'No AiroNotes yet'}
                </Typography>
                <Typography variant="body2" sx={{ color: 'text.disabled' }}>
                  {searchTerm ? 'Try adjusting your search terms' : 'Add your first AiroNote to get started'}
                </Typography>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
